<template>
  <div class="flex">
        <div class="content">
          <!-- <h1>{{ $route.params.pathname }}</h1> -->
          <h1>{{ $route.params.connected }}</h1>
          <h1>{{ $route.params.id }}</h1>
        </div>
  </div>      
</template>


<script>

export default {
  name:"quality",
    components:{
    },  
  data () {
    return {
    }
  },
  methods : {}
};
</script>
